/**
 * VestingLoader.js - Golden Crescent Moon Loading Component
 * Professional themed loading animation for vesting details page
 */

import React from 'react';
import { Moon } from 'lucide-react';
import './VestingLoader.css';

const VestingLoader = () => {
  return (
    <div className="vesting-loader-overlay">
      <div className="vesting-loader-container">
        {/* Animated Golden Crescent Moon */}
        <div className="moon-crescent-wrapper">
          <div className="moon-crescent">
            <Moon size={80} strokeWidth={2} />
          </div>
          <div className="moon-glow"></div>
          {/* Orbiting particles */}
          <div className="moon-particles">
            <span className="particle"></span>
            <span className="particle"></span>
            <span className="particle"></span>
          </div>
        </div>

        {/* Loading Text */}
        <div className="loader-text-container">
          <h2 className="loader-title">Loading Vesting Details</h2>
          <p className="loader-subtitle">Fetching your token distribution...</p>
        </div>

        {/* Animated Dots */}
        <div className="loader-dots">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
    </div>
  );
};

export default VestingLoader;

